export class DashboardFilters {
    jobNumbers : JobNumber[];
    rmhs : RMH[];
    jobTypes : JobType[];
    brands : Brand[];
    crops : Crop[];
    languages : Language[];
    requirementTypes : RequirementType[];
    //requirementYear : RequirementYear[];
    status : RequirementStatus[];
    year:Year[];
}

export class DashboardDetails {
    jobNumber : string;
    poNumber:string;
    rmhName : string;
    rmhid : string;
    jobType : string;
    brand : string;
    requirementType : string
    requirementYear : string
    crop : Crop;
    language : string;
    requestedQuantity : any;
    approvedQuantity : any;
    orderStatus : any;
    requirementMonth:any;
    estimatedDelivery : any;
    approvedOn : any;
    color: string;
    finalProductionQty:any;
}

export class RMH{
    rMHCode : string;
    rMHName : string;
}

export class Brand{
    brandID : string;
    brandName : string;
}

export class JobType{
    jobTypeID : number;
    jobTypeName : string;
}

export class RequirementType{
    requirementTypeID : number;
    requirementTypeName : string;
}
// export class RequirementYear{
//     // requirementTypeID : number;
//     // requirementYearID : any;
// }

export class Crop{
    cropID : number;
    cropName : string;
}

export class Language{
    languageID : number;
    languageName : string;
}

export class RequirementStatus{
    requirementStatusID : number;
    requirementStatusName : string;
}

export class Requesters{
    text : string;
}

export class JobNumber{
    jobNumber : string;
}
export class DropDownResponse {
    brands: Array<Brand> = new Array<Brand>()
    crops: Array<Crop> = new Array<Crop>()
    jobNumbers: Array<JobNumber> = new Array<JobNumber>()
    jobTypes: Array<JobType> = new Array<JobType>()
    languages: Array<Language> = new Array<Language>()
    requirementTypes: Array<RequirementType> = new Array<RequirementType>()
    requirementYear: Array<Year> = new Array<Year>()
    rmhs: Array<RMH> = new Array<RMH>()
    status: Array<RequirementStatus> = new Array<RequirementStatus>()
    requester:Array<Requesters> = new Array<Requesters>()
    year:Year[];
}

export class MultiSelectCancellation{
    JobNumber: string;
    Remarks: string;
    CancelledQty: number;
    ApprovedQty: number;
}

export class Year{
    year:any;
    currentrequirementYear:string;
}